import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { PageSubTitle, Text } from 'components/common/Elements/Elements';

import classes from './SidebarShowError.module.scss';

const SidebarShowError = ({ data }) => {
  const { t } = useTranslation(['activity']);

  return (
    <>
      <PageSubTitle
        title={`${t('activity:errors.ERROR')}`}
        className={classes.title}
        size={2}
      />
      <div className={classes.children}>
        <Text type={'p'}>{data.split(',').join(', ')}</Text>
      </div>
    </>
  );
};

SidebarShowError.propTypes = {
  data: PropTypes.string
};

export default SidebarShowError;
